export default "<app-index-navbar></app-index-navbar>\r\n<app-cutpaper></app-cutpaper>\r\n<app-footer></app-footer>\r\n";